import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium, widthLarge } = breakPoints;
const S = {};

S.HeroBlock = styled.section`
  label: HeroBlock;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6.5rem;
  padding-bottom: 3.5rem;
  text-align: center;

  @media (${widthSmall}) {
    padding-top: 8.5rem;
    padding-bottom: 4rem;
  }

  @media (${widthLarge}) {
    padding-top: 12.5rem;
    padding-bottom: 4.5rem;
  }
`;

S.HeroBlock.ImageWrapper = styled.div`
  label: ImageWrapper;

  position: absolute;
  top: 0;
  ${startDirection}: 0;
  width: 100%;
  height: 100%;
  z-index: var(--z-index-under-background);
`;

S.HeroBlock.Image = styled.img`
  label: Image;

  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

S.HeroBlock.TitleWrapper = styled.div`
  label: TitleWrapper;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 1.25rem;
  margin-bottom: 3.5rem;

  @media (${widthSmall}) {
    padding: 0;
    margin-bottom: 5rem;
  }

  @media (${widthLarge}) {
    margin-bottom: 7.5rem;
  }
`;

S.HeroBlock.Title = styled.h1`
  label: Title;

  color: ${props => `var(--colors-${props.titleColor})`};
  margin-bottom: 1.5rem;

  @media (${widthSmall}) {
    max-width: 24.375rem;
    margin-bottom: 2rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 2.5rem;
    max-width: 37.5rem;
  }
`;

export default S;
